"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13.99.99h-12a1.003 1.003 0 00-.71 1.71l4.71 4.71V14a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V7.41L14.7 2.7a1.003 1.003 0 00-.71-1.71z"];
//# sourceMappingURL=filter.js.map